import scrollMonitor from 'scrollmonitor';

export default class ScrollMonitor {
	init() {
		this.watchers = {};
	}

	get() {
		return scrollMonitor;
	}

	createWatcher( key, element ) {
		return ( this.watchers[ key ] = scrollMonitor.create( element ) );
	}

	getWatcher( key ) {
		return this.watchers[ key ];
	}
}
